import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StatisticEditorBase } from '../statistic-editor-base';

@Component({
	selector: 'pp-editor-datepicker',
	templateUrl: './editor-datepicker.component.html',
	styleUrls: ['./editor-datepicker.component.scss']
})
export class EditorDatePickerComponent extends StatisticEditorBase implements OnInit {
	form: FormGroup;

	constructor(
		private fb: FormBuilder,
	) {
		super();
	}

	ngOnInit() {
		this.buildForm();
		this.form.patchValue({
			text: this.convertToDate(this.statistic.text)
		});

		this.form.controls.text.valueChanges.subscribe(val => {
			this.statistic.text = moment(val).format('DD/MM/YYYY');
			this.emitChange();
		});
	}

	private convertToDate(dateString: string): Date {
		try{
			const [day, month, year] = dateString.split('/').map(part => parseInt(part, 10));
			var d = new Date(year, month - 1, day);
			if (isNaN(d.getTime())) {
				return null;
			}
			return d;
		}
		catch (error) {
			return null;
		}
	}

	private buildForm() {
		this.form = this.fb.group({
			text: Date || null
		});

		if (this.type.isRequired) {
			this.form.controls.text.setValidators(Validators.required);
		}
	}
}
